import React from 'react';
import Basepage, { BasePageState } from '../Basepage';
import { PageMode } from '../Basepage/parts/Definitions';
import ShopingCartItem from './Parts/ShopingCartItem';
import WebgainsBasketTag from './Parts/WebgainsBasketTag';

import $ from 'jquery';

import './index.scss';

import {
  showShippingWarming,
  useWebgains,
  getTelNummberLink,
  getTelNummber,
} from './overrides';
import { getObjectFromForm } from '../../../../mol_function';
import MolLink from '../Basepage/parts/Menu/MolLink';

interface ShoppingCartPageState extends BasePageState {}

interface ShoppingCartPageModel {
  items: ShoppingCartPageItemModel[];
  final_price_netto: number;
  final_price: number;
  final_tax: number;
  shipper_cost: number;
  shipper_cost_netto: number;
  shipper_cost_tax: number;
  messageStack: any[];
  FB_PIXEL: string[];
  country: {
    id: number;
    name: string;
    selected: boolean;
  }[];
  quick: string;
  sent_country: string;
  selectedAlpha: string;
}

export default class ShoppingCartPage extends Basepage<
  ShoppingCartPageState,
  ShoppingCartPageModel
> {
  onSubmitForm(target) {
    let result: any = getObjectFromForm(target);
    let resultKeys = Object.keys(result);

    let itemsArray: any = {};

    for (let i = 0; i < resultKeys.length; i++) {
      if (resultKeys[i].startsWith('cart_quantity_')) {
        let productId = +resultKeys[i].substring(14);
        if (itemsArray[productId] == undefined) itemsArray[productId] = {};
        itemsArray[productId]['quantity'] = +result[resultKeys[i]];
      } else if (resultKeys[i].startsWith('cart_mode_')) {
        let productId = +resultKeys[i].substring(10);
        if (itemsArray[productId] == undefined) itemsArray[productId] = {};
        itemsArray[productId]['mode'] = result[resultKeys[i]];
      } else if (resultKeys[i].startsWith('productDetInfo__')) {
        let splitPoint = resultKeys[i].indexOf('_', 16);
        let productId = +resultKeys[i].substring(16, splitPoint);
        let splitPoint2 = resultKeys[i].indexOf('_', splitPoint + 1);
        let detID = +resultKeys[i].substring(splitPoint + 1, splitPoint2);

        if (itemsArray[productId] == undefined) itemsArray[productId] = {};

        if (itemsArray[productId]['details'] == undefined)
          itemsArray[productId]['details'] = [];
        if (itemsArray[productId]['details'][detID] == undefined)
          itemsArray[productId]['details'][detID] = {};
        itemsArray[productId]['details'][detID]['count'] =
          result['productDetInfo__' + productId + '_' + detID + '_count'];
        itemsArray[productId]['details'][detID]['text'] =
          result['productDetInfo_' + productId + '_' + detID + '_text'];
      }
    }

    let item = JSON.stringify(itemsArray);

    let anyWin: any = window;

    anyWin.historyHelper.memory.push(
      '/shopping_cart/?update=' + encodeURI(item),
    );
  }

  renderChild(): JSX.Element {
    let messageStack = this.body.messageStack;

    if (messageStack == undefined) {
      messageStack = [];
    }

    let anyProps: any = this.props;

    if (anyProps.location.search != '') {
      let urlParams = new URLSearchParams(anyProps.location.search);

      let messageString: string | null = urlParams.get('message');
      if (messageString != null) {
        messageStack.push({ text: messageString });
      }
    }

    let messageContainer: JSX.Element | null = null;
    if (messageStack.length > 0) {
      messageContainer = (
        <div className="negmeldung">
          {messageStack.map((item, index) => {
            return (
              <div key={'meldung' + index}>
                <span
                  className="closebtn"
                  onClick={(e) => {
                    let tar: any = e.target;
                    tar.parentElement.style.display = 'none';
                  }}
                >
                  ×
                </span>
                <strong
                  style={{
                    color: 'red',
                  }}
                >
                  Achtung:{' '}
                </strong>
                <div
                  style={{ display: 'inline' }}
                  dangerouslySetInnerHTML={{
                    __html: item.text ?? item,
                  }}
                />
              </div>
            );
          })}
        </div>
      );
    }

    return (
      <div id="shoppingCart">
        {messageContainer}
        <div className="centerColumn" id="shoppingCartDefault">
          <div className="forward"></div>
          {/* 
          <h1>Ihr Warenkorb</h1>
          */}
          <form
            name="cart_quantity"
            onSubmit={(event) => {
              event.preventDefault();
              this.onSubmitForm(event.target);
            }}
          >
            <input
              type="hidden"
              name="securityToken"
              defaultValue={this.state.apiData.securityToken}
            />
            <div id="cartInstructionsDisplay" className="content"></div>

            <table
              width="100%"
              cellSpacing="0"
              cellPadding="0"
              id="cartContentsDisplay"
            >
              <thead>
                <tr className="tableHeading">
                  <th scope="col" id="scQuantityHeading">
                    Anzahl
                  </th>
                  {this.state.mode != PageMode.Mobile ? (
                    <React.Fragment>
                      <th scope="col" id="scUpdateQuantity">
                        &nbsp;
                      </th>
                    </React.Fragment>
                  ) : null}
                  <th scope="col" id="scProductsHeading">
                    Artikel
                  </th>
                  <th>Bezugsvariante</th>
                  {this.state.mode != PageMode.Mobile ? (
                    <React.Fragment>
                      <th scope="col" id="scUnitHeading">
                        Preis/Stk.
                      </th>
                      <th scope="col" id="scUnitHeading">
                        MwSt.
                      </th>
                    </React.Fragment>
                  ) : null}
                  <th scope="col" id="scTotalHeading">
                    Summe netto
                  </th>
                  {this.state.mode != PageMode.Mobile ? (
                    <React.Fragment>
                      <th scope="col" id="scRemoveHeading">
                        &nbsp;
                      </th>
                    </React.Fragment>
                  ) : null}
                </tr>
              </thead>
              <tbody>
                {/* <!-- Loop through all products /-->*/}
                {this.body.items != undefined && this.body.items.length > 0 ? (
                  this.body.items.map((item, index) => {
                    return (
                      <ShopingCartItem
                        index={index}
                        item={item}
                        mode={this.state.mode}
                        domainPrefix={this.state.renderingDomain}
                        key={'ShopingCartItem_' + index}
                      ></ShopingCartItem>
                    );
                  })
                ) : (
                  <React.Fragment>
                    <tr>
                      <td colSpan={this.state.mode != PageMode.Mobile ? 6 : 3}>
                        Ihr Warenkorb ist leer.
                      </td>
                    </tr>
                  </React.Fragment>
                )}
                {/* <!-- Finished loop through all products /--> */}
              </tbody>
            </table>
          </form>
          <div id="cartSubTotal" className="warenkorb">
            {/* 
              <div id="gutscheinfeld">
                <input
                  type="text"
                  id="dc_redeem_code"
                  name="dc_redeem_code"
                  defaultValue="Gutscheincode"
                  onFocusCapture={(e) => {
                    if (e.target.value == 'Gutscheincode') {
                      e.target.value = '';
                    }
                  }}
                  onBlur={(e) => {
                    if (e.target.value == '') {
                      e.target.value = 'Gutscheincode';
                    }
                  }}
                  //onFocus="emptyfield();"
                  //onblur="restoredefault();"
                />
                &nbsp;
                <input
                  className="cssButton submit_button button"
                  onMouseOver={(e) => {
                    let target: any = e.target;
                    target.className = 'cssButtonHover Hover';
                  }}
                  onMouseOut={(e) => {
                    let target: any = e.target;
                    target.className = 'cssButton submit_button button';
                  }}
                  type="submit"
                  value="Code einlösen"
                />
              </div>
            */}
            <div id="bezahlen">
              <div className="cart_summe">
                <div className="cart_summe_row">
                  <span className="cart_summe_Text">Zwischensumme:</span>
                  <span className="cart_summe_Number">
                    {this.body.final_price_netto.toFixed(2).replace('.', ',')} €
                  </span>
                </div>

                <div className="cart_summe_row">
                  <div className="cart_summe_Text">
                    Versandkosten nach:
                    <br />
                    <select
                      name="land_schipping"
                      id="land_schipping"
                      style={{ width: '120px' }}
                      onChange={(e) => {
                        let newIndex = e.target.value;

                        let anyWin: any = window;

                        anyWin.historyHelper.memory.push(
                          '/shopping_cart/?schippingCountry=' + newIndex,
                        );
                      }}
                    >
                      {this.body.country.map((item, index) => {
                        return (
                          <option value={item.id} selected={item.selected}>
                            {item.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  {this.body.sent_country == '81' ? (
                    <>
                      <a
                        href="https://www.buchbutler.de/versandkosten"
                        target="_blank"
                      >
                        Porto !!
                      </a>
                    </>
                  ) : (
                    <>
                      <a
                        href={
                          'https://www.buchbutler.de/versandkosten/' +
                          this.body.selectedAlpha
                        }
                        target="_blank"
                      >
                        shipping
                        <br />
                        costs !!
                      </a>
                    </>
                  )}
                  {/*
                  <span className="cart_summe_Number">
                    {this.body.shipper_cost_netto.toFixed(2).replace('.', ',')}{' '}
                    €
                  </span>
                  */}
                </div>

                <div className="cart_summe_row">
                  <span className="cart_summe_Text">MwSt:</span>
                  <span className="cart_summe_Number">
                    {(this.body.final_tax + this.body.shipper_cost_tax)
                      .toFixed(2)
                      .replace('.', ',')}{' '}
                    €
                  </span>
                </div>
                <div className="cart_summe_row">
                  <span className="cart_summe_Text">
                    Zwischensumme (inkl. MwSt.):
                  </span>
                  <span className="cart_summe_Number">
                    {(this.body.final_price + this.body.shipper_cost)
                      .toFixed(2)
                      .replace('.', ',')}{' '}
                    €
                  </span>
                </div>
              </div>
            </div>

            <div className="warenkorb-kasse-AGB">
              Mit dem Klick auf den Button: "zur Kasse gehen" bestätigen und
              akzeptieren Sie unsere{' '}
              <a
                href="/AGB"
                title="Allgemeine Geschäftsbedingungen"
                target={'_blank'}
              >
                Allgemeinen Geschäftsbedingungen.
              </a>
              <br />
              Mit dem Klick auf den Button: "zur Kasse gehen" bestätigen Sie,
              dass Sie kein privater Endkunde sind.
            </div>
            {this.body.items.length > 0 ? (
              <div className="warenkorb-kasse">
                <MolLink to="/checkout_VR" href="/checkout_VR">
                  <input
                    className="button_in_checkout kasse"
                    type="submit"
                    value="zur Kasse gehen"
                  />
                </MolLink>
                {/* 
              <a href={'/index.php?main_page=page&id=5&checkout=paypal_v2'}>
                <input
                  className="button_in_paypal"
                  type="submit"
                  value="Checkout"
                />
              </a>
              */}
              </div>
            ) : null}
          </div>
          {/* <!-- cartSubTotal ENDE --> */}
          <br className="clearBoth" />
          <hr style={{ border: '1px solid #c20f0d' }} />

          <div id="quickcontainer">
            <div id="quick">
              <span>Schnelleingabe</span>
              <br />
              <textarea
                id="quick_text"
                placeholder="EAN bzw. ISBN, Menge"
                defaultValue={this.body.quick}
              />

              <br />
              <button
                className="button_in_checkout"
                onClick={() => {
                  let val = $('#quick_text').val();
                  let text: string = val?.toString() ?? '';
                  if (text != '') {
                    let anyWin: any = window;

                    anyWin.historyHelper.memory.push(
                      '/shopping_cart/?quick_buy=' + encodeURI(text),
                    );
                  }
                }}
              >
                Zum Warenkorb hinzufügen
              </button>
            </div>

            <div id="quick_notize">
              Hier können Sie je Zeile eine ISBN oder EAN eintragen und so
              bequem Ihren Warenkorb füllen.
              <br />
              <br />
              Wird keine Menge eingegeben wird jeweils ein Exemplare des Titels
              in den Warenkorb gelegt.
              <br />
              <br />
              Wenn Sie eine Menge größer 1 in den Warenkorb legen wollen, tippen
              Sie hinter der EAN/ISBN einfach ein Komma und dahinter die Anzahl.
              <br />
              <br />
              WICHTIG: Es darf nur je Zeile eine ISBN/EAN eingetragen werden,
              also je Zeile ein Titel.
            </div>
          </div>

          {useWebgains() ? (
            <WebgainsBasketTag items={this.body.items}></WebgainsBasketTag>
          ) : null}
          {showShippingWarming() ? (
            <div id="achtung">
              <span style={{ color: '#ff0000' }}>⚠</span> Bitte beachten Sie:
              wenn Sie eine Lieferung an eine Adresse außerhalb von Deutschland
              wünschen, melden Sie sich bitte bei uns.
              <br />
              Gerne über unser{' '}
              <a href={'/index.php?main_page=contact_us'}>
                <u>Kontaktformular</u>
              </a>{' '}
              oder per Telefon:{' '}
              <a href={getTelNummberLink()}>☎ {getTelNummber()}</a>. Die
              Versandkosten finden Sie{' '}
              <u>
                <a
                  href={'/index.php?main_page=page&amp;id=126'}
                  title="Verssandkosten Ausland"
                >
                  hier
                </a>
              </u>
              .<br />
              <br />
              <span style={{ color: '#ff0000' }}>⚠</span> Please note: if you
              want delivery to an address outside of Germany, please contact us.
              <br />
              Gladly via our{' '}
              <a href={'/index.php?main_page=contact_us'}>
                <u>contact form</u>
              </a>{' '}
              or by phone: <a href={getTelNummberLink()}>☎ {getTelNummber()}</a>
              . Click{' '}
              <u>
                <a
                  href={'/index.php?main_page=page&amp;id=126'}
                  title="Verssandkosten Ausland"
                >
                  here
                </a>
              </u>{' '}
              to see the shipping cost.
            </div>
          ) : null}
        </div>
      </div>
    );
  }

  initState(base: BasePageState): ShoppingCartPageState {
    let newState: ShoppingCartPageState = {
      ...base,
    };

    return newState;
  }
  getApiReqestUrl(checkOnly: boolean): string {
    let anyProps: any = this.props;
    let oneCommand = '';

    let oneCommandItem: any = null;

    if (
      anyProps.location != undefined &&
      (anyProps.location.search.includes('?add=') ||
        anyProps.location.search.includes('?update='))
    ) {
      let urlParams = new URLSearchParams(anyProps.location.search);

      if (anyProps.location.search.includes('?add=')) {
        let jsonString: string | null = urlParams.get('add');
        if (jsonString != null) {
          let item = JSON.parse(jsonString);
          oneCommandItem = { command: 'addToBasket', commandParams: item };
        }
      } else if (anyProps.location.search.includes('?update=')) {
        let jsonString: string | null = urlParams.get('update');
        if (jsonString != null) {
          let item = JSON.parse(jsonString);
          oneCommandItem = { command: 'updateBasket', commandParams: item };
        }
      }
    } else if (
      anyProps.location != undefined &&
      anyProps.location.search.includes('?schippingCountry=')
    ) {
      let urlParams = new URLSearchParams(anyProps.location.search);
      let newCountry: string | null = urlParams.get('schippingCountry');

      oneCommandItem = {
        command: 'changeSchippingCountry',
        commandParams: newCountry,
      };
    } else if (
      anyProps.location != undefined &&
      anyProps.location.search.includes('?quick_buy=')
    ) {
      let urlParams = new URLSearchParams(anyProps.location.search);
      let quick_body = urlParams.get('quick_buy') ?? '';

      oneCommandItem = {
        command: 'quick_buy',
        commandParams: quick_body,
      };
    }

    if (oneCommandItem != undefined) {
      oneCommand = '?oneCommand=' + encodeURI(JSON.stringify(oneCommandItem));
      if (!checkOnly && this.state.oneCommand != oneCommand) {
        this.setState({ oneCommand: oneCommand });
      }
    }

    return this.state.apiBase + '/ShoppingCart.php' + oneCommand;
  }

  releaseOneCommand(): void {
    let anyProps: any = this.props;
    anyProps.location.search = '';
  }

  childDidMount(): void {}
  childDidUnmount(): void {}

  initJSChild(): string {
    let initjs = '';
    //TODO: FB_PIXEL
    /*
    if (this.body.FB_PIXEL != null) {
      initjs += `
      !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
        n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);
        //t.async=!0;
        t.src=v;
        s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
        document,'script','//connect.facebook.net/en_US/fbevents.js');
        // Insert Your Facebook Pixel ID below. 
        fbq('init', '1300907099926580');
        
        fbq('init', '417368186590646'); //FB_MOLUNA_20211117_14

        fbq('track', 'PageView');
        `;

      for (let i = 0; i < this.body.FB_PIXEL.length; i++) {
        initjs += this.body.FB_PIXEL[i];
      }
      
    }
    */
    return initjs;
  }
  childDidUpdate(prevProp: any, prevState: any): void {}
  getRightBreadCrumbParts(): JSX.Element {
    return null;
  }
  pageHeaderGetter(): string {
    return '<meta name="robots" content="noindex">';
  }
  pageTitleGetter(): string {
    return 'Warenkorb';
  }
  getBreadCrumb(): JSX.Element {
    return <span>Warenkorb</span>;
  }
  getType(): string {
    return 'ShoppingCartPage';
  }
}
